import { render } from "./BoxSpinner.vue?vue&type=template&id=29e46542&scoped=true"
const script = {}

import "./BoxSpinner.vue?vue&type=style&index=0&id=29e46542&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29e46542"]])

export default __exports__